import { render, staticRenderFns } from "./RightInfoPanelGeneric.vue?vue&type=template&id=4265f2b2&scoped=true"
import script from "./RightInfoPanelGeneric.vue?vue&type=script&lang=js"
export * from "./RightInfoPanelGeneric.vue?vue&type=script&lang=js"
import style0 from "./RightInfoPanelGeneric.vue?vue&type=style&index=0&id=4265f2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4265f2b2",
  null
  
)

export default component.exports